import { createFileRoute } from "@tanstack/react-router";
import { VideoViewPage } from "@/components/v/VideoViewPage";

export const Route = createFileRoute("/s/$slug")({
  component: RouteComponent,
});

function RouteComponent() {
  const { slug } = Route.useParams();
  return <VideoViewPage mode="public" slug={slug} />;
}
